import axios from "axios";

export const setAxiosHeaderConfiguration = (token) => {

    axios.interceptors.request.use(function (config) {
        config.headers.Authorization = `Bearer ${token}`

        return config;
    }, function (error) {
        console.log(error);
    });


    axios.interceptors.response.use(
        function (response) {
            return response;
        }, 
        function (error) {
            if (error.response && error.response.status === 401) {
                console.log("check: error 401 Token Expired");
                window.location.reload();
            }
            console.log(error);
            
        }
    );
}
